import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/index.css";
import App from "@/App";
import EmergencyRestore from "@/components/emergency/EmergencyRestore";
import PublicSalePage from "@/components/public/PublicSalePage";
import PublicRootRedirect from "@/components/public/PublicRootRedirect";
import MobileMockupDemo from "@/components/public/MobileMockupDemo";
import { LanguageProvider } from "@/i18n/LanguageContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <LanguageProvider>
    <BrowserRouter>
      <PublicRootRedirect>
        <Routes>
          {/* Page de restauration d'urgence - accessible sans connexion */}
          <Route path="/emergency-restore" element={<EmergencyRestore />} />
          {/* Page publique de diffusion des billets (sans auth) */}
          <Route path="/vente/:projectSlug" element={<PublicSalePage />} />
          {/* DEMO MOCKUP version mobile (pour validation visuelle) */}
          <Route path="/demo/mobile" element={<MobileMockupDemo />} />
          {/* Application principale */}
          <Route path="/*" element={<App />} />
        </Routes>
      </PublicRootRedirect>
    </BrowserRouter>
    </LanguageProvider>
  </React.StrictMode>,
);
